<template>
    <div class="overlay-back" v-on:click="closeContMenu()" v-show="contMenuOpened()">
        <div class="cont-menu">
            <div class="x-icon icon close" v-on:click="closeContMenu()"></div>
            <LoginComponentHomePage></LoginComponentHomePage>
        </div>
    </div>
</template>

<script>

import { mapState, mapActions, mapGetters } from 'vuex'
import FooterMobile from './../FooterMobile.vue'
import LoginComponentHomePage from '../authentication/LoginComponentHomePage.vue'

export default {
    name: 'ContMenu',
    data: function() {
        return {
        };
    },
    components: {
        FooterMobile,
        LoginComponentHomePage
    },
    props: {
    },
    computed: {
    },
    mounted: function() {
    },
    methods: {
        ...mapGetters('cont', [
            'contMenuOpened'
        ]),

        ...mapGetters('cont', [
            'closeContMenu'
        ]),
        ...mapActions('cont', [
            'toogleContMenu'
        ]),

        ...mapActions('cont', [
            'closeContMenu'
        ]),

        open() {
            this.toogleContMenu();
        }
    },
    watch: {
        '$route' (to, from) {
            this.closeContMenu();
        }
    }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped lang="scss">

.cont-menu {
    position: absolute;
    width: 95%;
    height: 100%;
    color: #000;
    background: #FAF9F6;
    z-index: 2000;
    overflow-y:auto;
    right: 0;
    padding: 20px;
    a {
        color: #000;
    }
    .col-lg-9{
        padding: 100px 0 0 0;

    }

    .in {
        padding: 25px;
    }

    .menu-item {
        display: block;
        padding: 10px 0;
        margin-bottom: 5px;
        margin-right: 30px;
    }

    .close {
        font-size: 24px;
        right: 0;
        top: 0;
    }
    .wrapper {       
       .sau {
            margin: 0;
            padding-top: 25px !important;
        }
    }
}
    
// AMINATIONS

</style>
